import { apiActionsBillingGroupPricing } from "middlewares/veritas-middleware/constants/ApiMiddlewareConstants";
import { BGPricingActionTypes } from "../constants/BillingGroupActionConstants";

import authService from "auth/AuthService";

const newVar = {
    BGPricingActionTypes,
    apiActionsBillingGroupPricing,
};
export default newVar;

export function toggleModalBGPricingScheme(billingGroupID) {
    return {
        type: BGPricingActionTypes.TOGGLE_ADD_MODAL_BG_PRICING_SCHEME,
        payload: { billingGroupID }
    }
}

export function toggleAddBGCountryPricingModal(billingGroupID, pricingScheme, pricingJsonKey) {
    return {
        type: BGPricingActionTypes.TOGGLE_ADD_BG_COUNTRY_PRICING_MODAL,
        payload: { billingGroupID, pricingScheme, pricingJsonKey }
    }
}

export function closeModalBGCountryPricing() {
    return {
        type: BGPricingActionTypes.CLOSE_MODAL_BG_COUNTRY_PRICING,
        payload: {}
    }
}

export function submitBGPricingForm(payload) {
    return {
        type: BGPricingActionTypes.SUBMIT_BG_PRICING_FORM,
        payload: { ...payload }
    }
}

export function selectBGPricingFormScheme({ pricingScheme }) {
    return {
        type: BGPricingActionTypes.SELECT_BG_PRICING_FORM_SCHEME,
        payload: { pricingScheme }
    }
}

export function selectBGPricingFormCountry({ country }) {
    return {
        type: BGPricingActionTypes.SELECT_BG_PRICING_FORM_COUNTRY,
        payload: { country }
    }
}

export function setBGPricingFormFlatPrice(payload) {
    return {
        type: BGPricingActionTypes.SET_BG_PRICING_FORM_FLAT_PRICE,
        payload: { ...payload }
    }
}

export function addBGPricingFormVolumeTier() {
    return {
        type: BGPricingActionTypes.ADD_BG_PRICING_FORM_VOLUME_TIER,
        payload: {}
    }
}

export function setBGPricingFormVolumeTier(payload) {
    return {
        type: BGPricingActionTypes.SET_BG_PRICING_FORM_VOLUME_TIER,
        payload: { ...payload }
    }
}

export function deleteBGPricingFormVolumeTier(payload) {
    return {
        type: BGPricingActionTypes.DELETE_BG_PRICING_FORM_VOLUME_TIER,
        payload: { ...payload }
    }
}

export function deleteBGPricingWarning(countryPricingID) {
    return {
        type: BGPricingActionTypes.DELETE_BG_PRICING_WARNING,
        payload: countryPricingID
    }
}

export function openEditBGCountryPricingModal(countryRecord) {
    return {
        type: BGPricingActionTypes.TOGGLE_EDIT_BG_COUNTRY_PRICING_MODAL,
        payload: countryRecord
    }
}

export function deleteBGCountryPricing(billingGroupID, countryPricingID) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(deleteCurrentBGCountryPricing(authToken, billingGroupID, countryPricingID))
    }
}

const deleteCurrentBGCountryPricing = (authToken, billingGroupID, countryPricingID) => ({
    type: apiActionsBillingGroupPricing.DELETE,
    payload: { authToken, billingGroupID, countryPricingID }
})


export function fetchBGPricingTables(billingGroupID) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(fetchCurrentBGPricingTables(billingGroupID, authToken))
    }
}
const fetchCurrentBGPricingTables = (billingGroupID, authToken) => ({
    type: apiActionsBillingGroupPricing.GET,
    payload: { billingGroupID, authToken }
})

export function setBGCountryPricing(payload) {
    return {
        type: BGPricingActionTypes.SET_BG_COUNTRY_PRICING,
        payload: { ...payload }
    }
}


